import React from 'react';
import Form from "react-bootstrap/Form";

function InputNovaSenha({ id, type, placeholder, name, value, onChange, maxLength, min, max, step, inputMode }) {
    return (
        <Form.Control
            id={id}
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            min={min}
            max={max}
            step={step}       // incrementos permitidos (útil em setas do input)
            inputMode={inputMode}
            required
        />
    );
}

export default InputNovaSenha;